import { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Layout from './Layout'
import VisualizadorDocumento from './VisualizadorDocumento'
import FluxoProgresso from '../components/FluxoProgresso'
import { listarSecretarias, resumirProcesso, apensarProcesso, listarModelos } from '../services/api'
import api from '../services/api'

const SBG = { aberto:'#E6F1FB', tramitando:'#FAEEDA', pendente:'#FAEEDA', concluido:'#EAF3DE', arquivado:'#F1EFE8', sobrestado:'#EEEDFE', recurso:'#FCEBEB' }
const SL_EXTRA = { recurso:'⚖️ Em recurso' }
const SC  = { aberto:'#185FA5', tramitando:'#854F0B', pendente:'#854F0B', concluido:'#3B6D11', arquivado:'#5F5E5A', sobrestado:'#534AB7', recurso:'#791F1F' }
const SL  = { aberto:'Aberto', tramitando:'Em tramitação', pendente:'Pendente docs', concluido:'Concluído', arquivado:'Arquivado', sobrestado:'Sobrestado', recurso:'⚖️ Em recurso' }
const IT  = { despacho:'💬', tramitacao:'➡️', pendencia:'⚠️', conclusao:'✅', arquivamento:'📦', abertura:'📂' }
const SIGILO = {
  publico:  { label:'Público',  bg:'#EAF3DE', cor:'#27500A', icone:'🌐' },
  restrito: { label:'Restrito', bg:'#FAEEDA', cor:'#633806', icone:'🔒' },
  sigiloso: { label:'Sigiloso', bg:'#FCEBEB', cor:'#791F1F', icone:'🔐' },
}
const VIS = {
  publico:  { label:'Público',  bg:'#EAF3DE', cor:'#27500A', icone:'🌐', desc:'Visível na consulta pública' },
  restrito: { label:'Restrito', bg:'#FAEEDA', cor:'#633806', icone:'🔒', desc:'Só servidores internos' },
  privado:  { label:'Privado',  bg:'#FCEBEB', cor:'#791F1F', icone:'🔐', desc:'Só o solicitante e servidores' },
}
const tipos_tram = [
  { value:'despacho',     label:'Despacho / informação' },
  { value:'tramitacao',   label:'Encaminhar para outro setor' },
  { value:'pendencia',    label:'Solicitar documentos' },
  { value:'conclusao',    label:'Concluir processo' },
  { value:'arquivamento', label:'Arquivar processo' },
]

export default function DetalheProcesso() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [processo, setProcesso] = useState(null)
  const [docs, setDocs] = useState([])
  const [secretarias, setSecretarias] = useState([])
  const [modelos, setModelos] = useState([])
  const [fluxoSugestao, setFluxoSugestao] = useState(null)
  const [load, setLoad] = useState(true)
  const [aba, setAba] = useState('tramitar')
  const [tramForm, setTramForm] = useState({ tipo:'despacho', descricao:'', setor_destino_id:'' })
  const [tramLoad, setTramLoad] = useState(false)
  const [tramErro, setTramErro] = useState('')
  const [tramSucesso, setTramSucesso] = useState('')
  const [uploadLoad, setUploadLoad] = useState(false)
  const [uploadVis, setUploadVis] = useState('restrito')
  const [resumo, setResumo] = useState('')
  const [resumoLoad, setResumoLoad] = useState(false)
  const [apensarForm, setApensarForm] = useState({ numero:'', tipo:'apenso' })
  const [apensarMsg, setApensarMsg] = useState('')
  const [docVisualizar, setDocVisualizar] = useState(null)
  const [alterandoSigilo, setAlterandoSigilo] = useState(false)
  const [respondendoRecurso, setRespondendoRecurso] = useState(false)
  const [recursoForm, setRecursoForm] = useState({ decisao:'aprovado', justificativa:'' })

  useEffect(() => {
    carregar()
    listarSecretarias().then(r => setSecretarias(r.data)).catch(() => {})
    listarModelos().then(r => setModelos(r.data)).catch(() => {})
    carregarDocs()
  }, [id])

  async function carregar() {
    setLoad(true)
    try {
      const r = await api.get(`/processos/${id}`)
      setProcesso(r.data)
      // Buscar sugestão usando fluxo_passo_atual do processo
      if (r.data.tipo_id) {
        const passoAtual = r.data.fluxo_passo_atual || 0
        api.get(`/fluxos/${r.data.tipo_id}/proximo/${id}`, { params: { passo_atual: passoAtual } })
          .then(res => {
            setFluxoSugestao(res.data)
            if (res.data.sugestao?.setor_id) {
              setTramForm(f => ({ ...f, setor_destino_id: res.data.sugestao.setor_id, tipo:'tramitacao' }))
            }
            if (res.data.concluir) {
              setTramForm(f => ({ ...f, tipo:'conclusao' }))
            }
          }).catch(() => {})
      }
    } catch { navigate('/processos') }
    setLoad(false)
  }

  async function carregarDocs() {
    try { const r = await api.get(`/documentos/${id}`); setDocs(r.data) } catch {}
  }

  const setTram = (k,v) => setTramForm(f => ({...f,[k]:v}))

  async function tramitar() {
    if (!tramForm.descricao) { setTramErro('Descrição é obrigatória'); return }
    setTramErro(''); setTramLoad(true)
    try {
      const novoStatus = tramForm.tipo==='conclusao'?'concluido':tramForm.tipo==='arquivamento'?'arquivado':tramForm.tipo==='pendencia'?'pendente':tramForm.tipo==='tramitacao'?'tramitando':undefined
      await api.post(`/processos/${id}/tramitar`, { ...tramForm, novo_status:novoStatus, setor_destino_id:tramForm.setor_destino_id||undefined })
      setTramSucesso('Andamento registrado!')
      setTramForm({ tipo:'despacho', descricao:'', setor_destino_id:'' })
      setFluxoSugestao(null)
      setTimeout(() => setTramSucesso(''), 3000)
      await carregar() // carregar já vai buscar nova sugestão
    } catch(e) { setTramErro(e.response?.data?.erro || 'Erro ao tramitar') }
    finally { setTramLoad(false) }
  }

  async function fazerUpload(files) {
    setUploadLoad(true)
    for (const arq of files) {
      const form = new FormData()
      form.append('arquivo', arq)
      form.append('visibilidade', uploadVis)
      try { await api.post(`/documentos/upload/${id}`, form, { headers: { 'Content-Type':'multipart/form-data' } }) } catch {}
    }
    setUploadLoad(false); carregarDocs()
  }

  async function alterarVisDoc(docId, vis) {
    try { await api.put(`/documentos/${docId}/visibilidade`, { visibilidade: vis }); carregarDocs() } catch {}
  }

  async function removerDoc(docId) {
    if (!window.confirm('Remover este documento?')) return
    try { await api.delete(`/documentos/${docId}`); carregarDocs() } catch {}
  }

  async function gerarResumo() {
    setResumoLoad(true); setResumo('')
    try { const r = await resumirProcesso(id); setResumo(r.data.resumo) }
    catch { setResumo('Não foi possível gerar o resumo.') }
    setResumoLoad(false)
  }

  async function alterarSigilo(nivel) {
    try { await api.put(`/processos/${id}/sigilo`, { sigilo: nivel }); setAlterandoSigilo(false); carregar() } catch {}
  }

  async function responderRecurso() {
    if (!recursoForm.justificativa) { setTramErro('Justificativa é obrigatória'); return }
    setTramLoad(true)
    try {
      await api.post(`/processos/${id}/responder-recurso`, recursoForm)
      setTramSucesso(`Recurso ${recursoForm.decisao === 'aprovado' ? 'deferido' : 'indeferido'}!`)
      setRespondendoRecurso(false)
      setRecursoForm({ decisao:'aprovado', justificativa:'' })
      setTimeout(() => setTramSucesso(''), 3000); carregar()
    } catch(e) { setTramErro(e.response?.data?.erro || 'Erro') }
    finally { setTramLoad(false) }
  }

  async function fazerApensar() {
    if (!apensarForm.numero) { setApensarMsg('Informe o número'); return }
    try {
      const res = await api.get(`/processos?busca=${apensarForm.numero}&limite=1`)
      const proc = res.data.processos?.[0]
      if (!proc) { setApensarMsg('Processo não encontrado'); return }
      await apensarProcesso(id, { processo_relacionado_id:proc.id, tipo:apensarForm.tipo })
      setApensarMsg('Vínculo criado!'); setApensarForm({ numero:'', tipo:'apenso' }); carregar()
    } catch(e) { setApensarMsg(e.response?.data?.erro || 'Erro') }
  }

  function formatBytes(b) {
    if(!b) return ''
    return b<1024*1024?(b/1024).toFixed(0)+' KB':(b/1024/1024).toFixed(1)+' MB'
  }

  const sigiloAtual = SIGILO[processo?.sigilo || 'publico']

  if (load) return <Layout><div style={{ padding:40, textAlign:'center', color:'#9ca3af' }}>Carregando...</div></Layout>
  if (!processo) return null

  return (
    <Layout>
      {docVisualizar && <VisualizadorDocumento doc={docVisualizar} onFechar={() => setDocVisualizar(null)} />}
      {alterandoSigilo && <div style={{ position:'fixed', inset:0, zIndex:99 }} onClick={() => setAlterandoSigilo(false)} />}

      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:20 }}>
        <span onClick={() => navigate('/processos')} style={{ fontSize:13, color:'#6b7280', cursor:'pointer' }}>← Processos</span>
        <span style={{ color:'#e5e7eb' }}>›</span>
        <span style={{ fontSize:13, fontFamily:'monospace', color:'#185FA5', fontWeight:600 }}>{processo.numero}</span>
      </div>

      {/* FLUXO DE PROGRESSO */}
      <FluxoProgresso processo={processo} />

      <div style={{ display:'grid', gridTemplateColumns:'1fr 360px', gap:20 }}>
        <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:16 }}>
              <div>
                <div style={{ fontSize:16, fontWeight:600 }}>{processo.assunto}</div>
                <div style={{ fontSize:13, color:'#9ca3af', marginTop:2 }}>{processo.tipo_nome||'Sem tipo'}</div>
              </div>
              <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                <div style={{ position:'relative', zIndex:100 }}>
                  <span onClick={() => setAlterandoSigilo(!alterandoSigilo)}
                    style={{ background:sigiloAtual.bg, color:sigiloAtual.cor, padding:'4px 10px', borderRadius:99, fontSize:11, fontWeight:500, cursor:'pointer', whiteSpace:'nowrap' }}>
                    {sigiloAtual.icone} {sigiloAtual.label}
                  </span>
                  {alterandoSigilo && (
                    <div style={{ position:'absolute', right:0, top:30, background:'white', border:'1px solid #e5e7eb', borderRadius:8, padding:8, minWidth:180, boxShadow:'0 4px 12px rgba(0,0,0,0.1)', zIndex:101 }}>
                      <div style={{ fontSize:11, color:'#9ca3af', marginBottom:6, padding:'0 4px' }}>Sigilo do processo</div>
                      {Object.entries(SIGILO).map(([k,v]) => (
                        <div key={k} onClick={() => alterarSigilo(k)} style={{ padding:'7px 10px', borderRadius:6, cursor:'pointer', fontSize:12, display:'flex', alignItems:'center', gap:6, background:processo.sigilo===k?v.bg:'transparent', color:processo.sigilo===k?v.cor:'#374151' }}>
                          {v.icone} {v.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <span style={{ background:SBG[processo.status]||'#f3f4f6', color:SC[processo.status]||'#374151', padding:'4px 12px', borderRadius:99, fontSize:12, fontWeight:500, whiteSpace:'nowrap' }}>
                  {SL[processo.status]||processo.status}
                </span>
              </div>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12 }}>
              {[['Requerente',processo.req_nome],['CPF/CNPJ',processo.req_cpf_cnpj||'—'],['Telefone',processo.req_telefone||'—'],['E-mail',processo.req_email||'—'],['Setor atual',processo.setor_atual_nome||'—'],['Aberto em',new Date(processo.aberto_em).toLocaleDateString('pt-BR')],['Prazo',processo.prazo_em?new Date(processo.prazo_em).toLocaleDateString('pt-BR'):'—'],['Prioridade',processo.prioridade],['Responsável',processo.responsavel_nome||'—']].map(([l,v]) => (
                <div key={l}><div style={{ fontSize:11, color:'#9ca3af' }}>{l}</div><div style={{ fontSize:13, color:'#111', marginTop:1 }}>{v}</div></div>
              ))}
            </div>
            {processo.observacoes_internas && (
              <div style={{ marginTop:14, padding:12, background:'#fef9c3', borderRadius:8, fontSize:12, color:'#854d0e' }}><strong>Obs. internas:</strong> {processo.observacoes_internas}</div>
            )}
            <div style={{ marginTop:14 }}>
              <button onClick={() => window.open(`/processos/${id}/cartao`, '_blank')} style={{ padding:'6px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, cursor:'pointer', background:'white' }}>🖨 Imprimir cartão</button>
            </div>
          </div>

          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20 }}>
            <div style={{ fontSize:14, fontWeight:500, marginBottom:14 }}>Histórico de tramitações</div>
            {(!processo.tramitacoes||processo.tramitacoes.length===0)
              ? <div style={{ textAlign:'center', padding:20, color:'#9ca3af', fontSize:13 }}>Nenhuma tramitação registrada.</div>
              : processo.tramitacoes.map((t,i,arr) => (
                <div key={t.id||i} style={{ display:'flex', gap:12, paddingBottom:14, position:'relative' }}>
                  {i<arr.length-1&&<div style={{ position:'absolute', left:13, top:28, bottom:0, width:1, background:'#e5e7eb' }} />}
                  <div style={{ width:26, height:26, borderRadius:'50%', background:'#E6F1FB', border:'2px solid #B5D4F4', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, flexShrink:0, marginTop:2 }}>{IT[t.tipo]||'📋'}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:13, color:'#111' }}>{t.descricao}</div>
                    <div style={{ fontSize:11, color:'#9ca3af', marginTop:3 }}>{new Date(t.data_hora).toLocaleString('pt-BR')}{t.usuario_nome?` · ${t.usuario_nome}`:''}{t.setor_destino_nome?` → ${t.setor_destino_nome}`:''}</div>
                  </div>
                </div>
              ))
            }
          </div>
        </div>

        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
            <div style={{ display:'flex', borderBottom:'1px solid #f3f4f6' }}>
              {[{key:'tramitar',label:'Andamento'},{key:'docs',label:`Docs (${docs.length})`},{key:'apensar',label:'Vínculos'},{key:'resumo',label:'IA'}].map(a => (
                <div key={a.key} onClick={() => setAba(a.key)} style={{ flex:1, padding:'10px 4px', textAlign:'center', fontSize:12, cursor:'pointer', fontWeight:aba===a.key?500:400, color:aba===a.key?'#185FA5':'#9ca3af', borderBottom:aba===a.key?'2px solid #185FA5':'2px solid transparent', marginBottom:-0.5 }}>{a.label}</div>
              ))}
            </div>
            <div style={{ padding:16 }}>

              {aba==='tramitar'&&<>
                {processo.status!=='concluido'&&processo.status!=='arquivado'?<>

                  {/* AVISO DE RECURSO */}
                  {processo.status === 'recurso' && processo.recurso_status === 'pendente' && (
                    <div style={{ background:'#FCEBEB', border:'1px solid #F5A5A5', borderRadius:8, padding:12, marginBottom:12 }}>
                      <div style={{ fontSize:12, fontWeight:500, color:'#791F1F', marginBottom:4 }}>⚖️ Recurso em andamento</div>
                      <div style={{ fontSize:12, color:'#374151', marginBottom:4 }}>O cidadão interpôs recurso contra a decisão.</div>
                      {processo.prazo_recurso_em && (
                        <div style={{ fontSize:11, color:'#6b7280', marginBottom:8 }}>
                          Prazo para resposta: {new Date(processo.prazo_recurso_em).toLocaleDateString('pt-BR')}
                        </div>
                      )}
                      {!respondendoRecurso ? (
                        <button onClick={() => setRespondendoRecurso(true)}
                          style={{ padding:'5px 12px', background:'#791F1F', color:'white', border:'none', borderRadius:6, fontSize:12, cursor:'pointer' }}>
                          ⚖️ Responder recurso
                        </button>
                      ) : (
                        <div style={{ marginTop:8 }}>
                          <div style={{ display:'flex', gap:6, marginBottom:8 }}>
                            {[['aprovado','✅ Deferir recurso','#3B6D11'],['negado','❌ Indeferir recurso','#791F1F']].map(([k,l,c])=>(
                              <button key={k} onClick={()=>setRecursoForm(f=>({...f,decisao:k}))}
                                style={{ flex:1, padding:'6px', border:`2px solid ${recursoForm.decisao===k?c:'#e5e7eb'}`, borderRadius:8, fontSize:11, cursor:'pointer', background:recursoForm.decisao===k?'white':'white', color:recursoForm.decisao===k?c:'#6b7280', fontWeight:recursoForm.decisao===k?600:400 }}>
                                {l}
                              </button>
                            ))}
                          </div>
                          <textarea value={recursoForm.justificativa} onChange={e=>setRecursoForm(f=>({...f,justificativa:e.target.value}))}
                            placeholder="Justifique a decisão sobre o recurso..."
                            style={{ width:'100%', padding:'8px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, minHeight:70, resize:'vertical', boxSizing:'border-box', marginBottom:8 }} />
                          <div style={{ display:'flex', gap:6 }}>
                            <button onClick={responderRecurso} disabled={tramLoad}
                              style={{ flex:1, padding:'7px', background:recursoForm.decisao==='aprovado'?'#3B6D11':'#791F1F', color:'white', border:'none', borderRadius:6, fontSize:12, cursor:'pointer', fontWeight:500 }}>
                              {tramLoad?'Salvando...':'Confirmar decisão'}
                            </button>
                            <button onClick={()=>setRespondendoRecurso(false)}
                              style={{ padding:'7px 12px', border:'1px solid #d1d5db', borderRadius:6, fontSize:12, cursor:'pointer', background:'white' }}>
                              Cancelar
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* AVISO DE PENDÊNCIA */}
                  {processo.status === 'pendente' && (
                    <div style={{ background:'#fef9c3', border:'1px solid #fef08a', borderRadius:8, padding:12, marginBottom:12 }}>
                      <div style={{ fontSize:12, fontWeight:500, color:'#854d0e', marginBottom:4 }}>⚠️ Processo com pendência</div>
                      <div style={{ fontSize:12, color:'#374151', marginBottom:8 }}>Aguardando resposta ou documentos do solicitante.</div>
                      <div style={{ fontSize:11, color:'#6b7280' }}>Quando o solicitante enviar o documento, registre um andamento para retomar o processo.</div>
                      <button onClick={()=>setTramForm(f=>({...f,tipo:'tramitacao',setor_destino_id:processo.setor_anterior_id||''}))}
                        style={{ marginTop:8, padding:'4px 10px', background:'#854d0e', color:'white', border:'none', borderRadius:6, fontSize:11, cursor:'pointer' }}>
                        Retomar processo
                      </button>
                    </div>
                  )}

                  {/* SUGESTÃO DO PRÓXIMO PASSO */}
                  {fluxoSugestao?.sugestao && (
                    <div style={{ background:'#E6F1FB', border:'1px solid #B5D4F4', borderRadius:8, padding:12, marginBottom:12 }}>
                      <div style={{ fontSize:11, color:'#0C447C', fontWeight:500, marginBottom:4 }}>🔀 Próximo passo sugerido pelo fluxo</div>
                      <div style={{ fontSize:13, fontWeight:500, color:'#185FA5' }}>{fluxoSugestao.sugestao.nome_passo}</div>
                      {fluxoSugestao.sugestao.setor_nome && <div style={{ fontSize:12, color:'#6b7280', marginTop:2 }}>Setor: {fluxoSugestao.sugestao.setor_nome}</div>}
                      {fluxoSugestao.sugestao.descricao && <div style={{ fontSize:12, color:'#374151', marginTop:4, background:'white', borderRadius:6, padding:'4px 8px' }}>📋 {fluxoSugestao.sugestao.descricao}</div>}
                      <button onClick={() => {
                        setTramForm(f => ({ ...f, tipo:'tramitacao', setor_destino_id: fluxoSugestao.sugestao.setor_id || '' }))
                      }} style={{ marginTop:8, padding:'4px 10px', background:'#185FA5', color:'white', border:'none', borderRadius:6, fontSize:11, cursor:'pointer' }}>
                        Usar sugestão
                      </button>
                    </div>
                  )}
                  {fluxoSugestao?.concluir && (
                    <div style={{ background:'#EAF3DE', border:'1px solid #bbf7d0', borderRadius:8, padding:12, marginBottom:12 }}>
                      <div style={{ fontSize:11, color:'#3B6D11', fontWeight:500, marginBottom:4 }}>🏁 Este é o último passo do fluxo</div>
                      <div style={{ fontSize:13, color:'#3B6D11' }}>O processo está pronto para ser concluído.</div>
                      <button onClick={() => setTramForm(f => ({ ...f, tipo:'conclusao' }))}
                        style={{ marginTop:8, padding:'4px 10px', background:'#3B6D11', color:'white', border:'none', borderRadius:6, fontSize:11, cursor:'pointer' }}>
                        Marcar como concluído
                      </button>
                    </div>
                  )}

                  {modelos.length>0&&<div style={{ marginBottom:12 }}><label style={{ display:'block', fontSize:11, fontWeight:500, marginBottom:5, color:'#9ca3af', textTransform:'uppercase', letterSpacing:'0.4px' }}>Modelos rápidos</label><div style={{ display:'flex', flexWrap:'wrap', gap:4 }}>{modelos.slice(0,6).map(m=><button key={m.id} onClick={()=>setTramForm(f=>({...f,descricao:m.conteudo,tipo:m.tipo}))} style={{ padding:'3px 8px', background:'#f3f4f6', border:'1px solid #e5e7eb', borderRadius:99, fontSize:11, cursor:'pointer', color:'#374151' }}>{m.atalho||m.nome}</button>)}</div></div>}
                  <div style={{ marginBottom:10 }}><label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Tipo</label><select value={tramForm.tipo} onChange={e=>setTram('tipo',e.target.value)} style={{ width:'100%', padding:'7px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12 }}>{tipos_tram.map(t=><option key={t.value} value={t.value}>{t.label}</option>)}</select></div>
                  {tramForm.tipo==='tramitacao'&&<div style={{ marginBottom:10 }}>
                    <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Encaminhar para</label>
                    <select value={tramForm.setor_destino_id} onChange={e=>setTram('setor_destino_id',e.target.value)} style={{ width:'100%', padding:'7px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12 }}>
                      <option value="">Selecione</option>
                      {secretarias.filter(s=>!s.pai_id).map(s=><optgroup key={s.id} label={s.nome}><option value={s.id}>{s.nome}</option>{secretarias.filter(d=>d.pai_id===s.id).map(d=><option key={d.id} value={d.id}>  └ {d.nome}</option>)}</optgroup>)}
                    </select>
                    {fluxoSugestao?.sugestao?.setor_id === tramForm.setor_destino_id && tramForm.setor_destino_id && (
                      <div style={{ fontSize:11, color:'#185FA5', marginTop:4 }}>✓ Setor sugerido pelo fluxo</div>
                    )}
                  </div>}
                  <div style={{ marginBottom:10 }}><label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Descrição *</label><textarea value={tramForm.descricao} onChange={e=>setTram('descricao',e.target.value)} placeholder="Descreva o andamento..." style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, minHeight:80, resize:'vertical', boxSizing:'border-box' }} /></div>
                  {tramErro&&<div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:8, fontSize:12, color:'#dc2626', marginBottom:8 }}>{tramErro}</div>}
                  {tramSucesso&&<div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:8, fontSize:12, color:'#15803d', marginBottom:8 }}>{tramSucesso}</div>}
                  <button onClick={tramitar} disabled={tramLoad} style={{ width:'100%', padding:9, background:tramForm.tipo==='conclusao'?'#3B6D11':tramForm.tipo==='arquivamento'?'#5F5E5A':'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
                    {tramLoad?'Salvando...':tramForm.tipo==='conclusao'?'✓ Concluir':tramForm.tipo==='arquivamento'?'📦 Arquivar':'Registrar andamento'}
                  </button>
                </>:<div style={{ textAlign:'center', padding:20 }}><div style={{ fontSize:28, marginBottom:8 }}>{processo.status==='concluido'?'✅':'📦'}</div><div style={{ fontSize:13, fontWeight:500, color:processo.status==='concluido'?'#15803d':'#5F5E5A' }}>Processo {SL[processo.status]}</div></div>}
              </>}

              {aba==='docs'&&<>
                <div style={{ marginBottom:12 }}>
                  <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:6, color:'#374151' }}>Visibilidade dos novos documentos</label>
                  <div style={{ display:'flex', gap:6 }}>
                    {Object.entries(VIS).map(([k,v])=>(
                      <button key={k} onClick={()=>setUploadVis(k)} style={{ flex:1, padding:'6px 4px', border:`1.5px solid ${uploadVis===k?v.cor:'#e5e7eb'}`, borderRadius:8, fontSize:11, cursor:'pointer', textAlign:'center', background:uploadVis===k?v.bg:'white', color:uploadVis===k?v.cor:'#6b7280', fontWeight:uploadVis===k?500:400 }}>
                        {v.icone}<br/>{v.label}
                      </button>
                    ))}
                  </div>
                  <div style={{ fontSize:11, color:'#9ca3af', marginTop:4 }}>{VIS[uploadVis].desc}</div>
                </div>
                <div onClick={()=>{const i=document.createElement('input');i.type='file';i.multiple=true;i.onchange=e=>fazerUpload(Array.from(e.target.files));i.click()}}
                  style={{ border:'1px dashed #d1d5db', borderRadius:8, padding:14, textAlign:'center', cursor:'pointer', fontSize:13, color:'#6b7280', marginBottom:12 }}>
                  {uploadLoad?'⏳ Enviando...':'📎 Clique para anexar documentos'}
                </div>
                {docs.length===0
                  ?<div style={{ textAlign:'center', padding:16, color:'#9ca3af', fontSize:13 }}>Nenhum documento anexado.</div>
                  :docs.map(d=>{
                    const vis=VIS[d.visibilidade||'restrito']
                    return(
                      <div key={d.id} style={{ padding:'10px 0', borderBottom:'1px solid #f9fafb' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                          <span style={{ fontSize:18, cursor:'pointer' }} onClick={()=>setDocVisualizar(d)}>{d.nome_original?.toLowerCase().endsWith('.pdf')?'📄':'🖼'}</span>
                          <div style={{ flex:1, minWidth:0 }}>
                            <div onClick={()=>setDocVisualizar(d)} style={{ fontSize:12, color:'#185FA5', cursor:'pointer', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{d.nome_original}</div>
                            <div style={{ fontSize:11, color:'#9ca3af' }}>{formatBytes(d.tamanho_bytes)} · {new Date(d.enviado_em).toLocaleDateString('pt-BR')}{d.enviado_por_nome?` · ${d.enviado_por_nome}`:''}</div>
                          </div>
                          <button onClick={()=>setDocVisualizar(d)} style={{ padding:'3px 8px', border:'1px solid #d1d5db', borderRadius:6, fontSize:11, cursor:'pointer', background:'white' }}>👁 Ver</button>
                          <button onClick={()=>removerDoc(d.id)} style={{ background:'none', border:'none', color:'#dc2626', cursor:'pointer', fontSize:14 }}>✕</button>
                        </div>
                        <div style={{ display:'flex', gap:4, marginTop:6, marginLeft:30 }}>
                          {Object.entries(VIS).map(([k,v])=>(
                            <button key={k} onClick={()=>alterarVisDoc(d.id,k)} style={{ padding:'2px 8px', border:`1px solid ${d.visibilidade===k?v.cor:'#e5e7eb'}`, borderRadius:99, fontSize:10, cursor:'pointer', background:d.visibilidade===k?v.bg:'white', color:d.visibilidade===k?v.cor:'#9ca3af', fontWeight:d.visibilidade===k?500:400 }}>
                              {v.icone} {v.label}
                            </button>
                          ))}
                        </div>
                      </div>
                    )
                  })
                }
              </>}

              {aba==='apensar'&&<>
                <div style={{ fontSize:12, color:'#6b7280', marginBottom:14, lineHeight:1.5 }}><strong>Apenso:</strong> une permanentemente.<br/><strong>Anexo:</strong> une temporariamente.<br/><strong>Sobrestar:</strong> pausa este processo.</div>
                <div style={{ marginBottom:10 }}><label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Número do processo</label><input value={apensarForm.numero} onChange={e=>setApensarForm(f=>({...f,numero:e.target.value}))} placeholder="Ex: 2025/001.234" style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, fontFamily:'monospace', boxSizing:'border-box' }} /></div>
                <div style={{ marginBottom:12 }}><label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Tipo</label><select value={apensarForm.tipo} onChange={e=>setApensarForm(f=>({...f,tipo:e.target.value}))} style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12 }}><option value="apenso">Apensar (definitivo)</option><option value="anexo">Anexar (temporário)</option><option value="sobrestado">Sobrestar (pausar)</option></select></div>
                {apensarMsg&&<div style={{ background:apensarMsg.includes('!')?'#f0fdf4':'#fef2f2', border:`1px solid ${apensarMsg.includes('!')?'#bbf7d0':'#fecaca'}`, borderRadius:8, padding:8, fontSize:12, color:apensarMsg.includes('!')?'#15803d':'#dc2626', marginBottom:10 }}>{apensarMsg}</div>}
                <button onClick={fazerApensar} style={{ width:'100%', padding:9, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer' }}>Aplicar vínculo</button>
              </>}

              {aba==='resumo'&&<>
                <div style={{ fontSize:12, color:'#6b7280', marginBottom:12, lineHeight:1.5 }}>A IA analisa o histórico e gera um resumo executivo para tomada de decisão.</div>
                <button onClick={gerarResumo} disabled={resumoLoad} style={{ width:'100%', padding:9, background:'#534AB7', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', marginBottom:12 }}>
                  {resumoLoad?'⏳ Analisando...':'✨ Gerar resumo com IA'}
                </button>
                {resumo&&<div style={{ background:'#EEEDFE', border:'1px solid #AFA9EC', borderRadius:8, padding:14, fontSize:13, color:'#26215C', lineHeight:1.6, whiteSpace:'pre-wrap' }}>{resumo}</div>}
              </>}

            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
